import { mapRecord } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import type { LinkedRecordFieldValue, LinkedRecordFormValue } from "./linked-record.config";

/**
 * Lives apart from the field config so the control can use it without importing the config,
 * which imports the control.
 */
export const prefillLinkedRecord: NonNullable<
  FieldRegistryConfig<LinkedRecordFormValue[], LinkedRecordFieldValue>["prefill"]
> = ({ value, field, linkedRecords }) => {
  const entriesAllowed = field.params.entries_allowed;
  const linkedRecordIDs = value.split(",");

  if (entriesAllowed === "multiple") {
    const choices = linkedRecords?.filter(
      (record) =>
        linkedRecordIDs.includes(record.id.toString()) || linkedRecordIDs.includes(record.title),
    );
    return choices?.map(mapRecord) ?? [];
  }

  const [firstId] = linkedRecordIDs;
  const choice = linkedRecords?.find(
    (record) => record.id.toString() === firstId || record.title === firstId,
  );
  return choice ? [mapRecord(choice)] : [];
};
